import {Button, Dropdown, DropdownItem} from 'platform/components';
import {Center, Heading} from 'platform/foundation';

import {useGetCurrentUserInfoQuery} from '@dms/api/customer';
import i18n from '@dms/i18n';
import {EMPTY_PLACEHOLDER, useFocusControl} from '@dms/shared';

import {useBoolean} from 'shared/web';

import {useSwitchActiveBranch} from '../hooks/useSwitchActiveBranch';
import {HeaderButtonWrapper} from './HeaderButtonWrapper';
import {TopBarActionContainer} from './TopBarActionContainer';

export function BranchSelect() {
  const [isDropdownOpen, openDropdown, closeDropdown] = useBoolean();
  const {isDisabled} = useFocusControl();

  const {data: currentUserInfo} = useGetCurrentUserInfoQuery();
  const {switchActiveBranch, isChangingBranch, activeBranchId, pendingBranchId} =
    useSwitchActiveBranch();

  const getBranchByActiveId =
    currentUserInfo?.branches?.find((b) => b.id === activeBranchId) ?? null;

  if (!currentUserInfo?.branches || currentUserInfo?.branches?.length === 0) {
    return (
      <Heading
        data-testid="layout-header-myProfileAndSettings-activeBranch"
        headingLevel={2}
        size={4}
      >
        {getBranchByActiveId?.name ?? EMPTY_PLACEHOLDER}
      </Heading>
    );
  }

  return (
    <Dropdown
      data-testid="branchSelect-dropdown"
      closeOnSelect
      isOpen={isDropdownOpen}
      onOpen={openDropdown}
      onClose={closeDropdown}
      dropdownControl={
        <TopBarActionContainer>
          <Center height={12}>
            <HeaderButtonWrapper $isOpen={isDropdownOpen}>
              <Button
                aria-label="topBar"
                isLoading={isChangingBranch}
                variant="ghost"
                rightIcon={
                  isDropdownOpen ? 'navigation/arrow_drop_up' : 'navigation/arrow_drop_down'
                }
                title={`${i18n.t('entity.branch.labels.branch')}: ${getBranchByActiveId?.name ?? EMPTY_PLACEHOLDER}`}
                tabIndex={isDisabled ? -1 : 0}
                data-testid="branchSelect"
              />
            </HeaderButtonWrapper>
          </Center>
        </TopBarActionContainer>
      }
      placement="bottom-start"
      isHeightLimited
      isLazy
      lazyBehavior="unmount"
    >
      {currentUserInfo.branches.map((branch) => (
        <DropdownItem
          key={branch.id}
          label={branch.name}
          isDisabled={isChangingBranch}
          isLoading={isChangingBranch && branch.id === pendingBranchId}
          onClick={() => switchActiveBranch(branch.id, {onSuccess: closeDropdown})}
          data-testid={`branchSelect-${branch.name}`}
        />
      ))}
    </Dropdown>
  );
}
